import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                  <i className="ri-download-2-line text-lg text-white"></i>
                </div>
                <span className="text-lg font-bold text-white">爱液下载</span>
              </div>
              <p className="text-sm text-foreground-300 leading-relaxed">
                安全、快速、免费的资源下载平台。海量正版内容一键获取，支持多平台兼容，让您轻松找到所需资源。
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">热门分类</h4>
              <ul className="space-y-2.5">
                {categories.slice(0, 5).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-foreground-300 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">快速链接</h4>
              <ul className="space-y-2.5">
                <li>
                  <Link to="/" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">首页</Link>
                </li>
                <li>
                  <Link to="/category" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">全部分类</Link>
                </li>
                <li>
                  <Link to="/article" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">文章资讯</Link>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-foreground-300 hover:text-white transition-colors cursor-pointer">关于我们</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-white mb-4">联系我们</h4>
              <ul className="space-y-2.5">
                <li className="flex items-center gap-2 text-sm text-foreground-300">
                  <i className="ri-mail-line text-base"></i>
                  <span>support@aiyexiazai.com</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-300">
                  <i className="ri-phone-line text-base"></i>
                  <span>400-888-9999</span>
                </li>
                <li className="flex items-center gap-2 text-sm text-foreground-300">
                  <i className="ri-map-pin-line text-base"></i>
                  <span>北京市海淀区中关村科技园</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; 2026 爱液下载 版权所有 | 京ICP备2024000001号
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-400 hover:text-white transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-white transition-colors" rel="nofollow">用户协议</a>
            <a href="#" className="text-xs text-foreground-400 hover:text-white transition-colors" rel="nofollow">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}